import { ActivityV2 } from 'models/activityV2'
import { BaseEventCard } from './BaseEventCard'
import CellEventFormatterV2 from 'components/Tables/ActivityTableV2/CellEvent/CellEventFormatterV2'

interface GenericEventCardProps {
  event: ActivityV2
}

/**
 * Generic event card for all events that don't have specialized cards.
 * Uses the existing ActivityTableV2 formatter.
 */
export function GenericEventCard({ event }: GenericEventCardProps) {
  return (
    <BaseEventCard event={event}>
      <div className="font-inter text-sm leading-5 tracking-normal text-new-company-gray-500">
        <span className="text-fb-dark-green font-bold">{event.user_name}</span>
        <span> </span>
        <CellEventFormatterV2 event={event} />
      </div>
    </BaseEventCard>
  )
}
